import React from 'react';

export default function InputForm({
  label,
  type,
  input,
  spam,
  cols,
  register,
  placeholder,
  errors,
  errorsTwo,
  defaultValue,
  onChange,
  onBlur,
  value,
  checked,
  disabled
}) {
  return (
    <div className={`flex text-start flex-col w-full cols cols-${!cols || cols === 1 ? '1' : cols}`}>
      <label className="text-sm flex items-center m-1 font-semibold">
        <p>{label}</p>
        {spam && <span className="text-red-500">*</span>}
      </label>

      <input
        className={`${input} ${input === 'file-input'
          ? 'file-input-sm file-input-info file-input-bordered'
          : 'input-sm'
          } input-bordered bg-white focus:outline-none focus:ring-1 rounded-sm`}
        type={type}
        {...register}
        value={value} // Usa `value` si está definido
        checked={checked}
        onChange={onChange ? onChange : null}
        disabled={disabled} // Aplicar el estado de deshabilitado si está definido
      />
      {errors}
      {errorsTwo}
    </div>
  );
}